import axios from "axios";
import cachios from "cachios";

const cacheAxiosInstance = axios.create({
	baseURL: 'https://api.aref-medical.com',
	headers:{
		'x-center-token':'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjE1Iiwicm9sZSI6ImNlbnRlciIsImlhdCI6MTY4Nzk3MDYzNH0.fQPYeO82gbdxnYfnkbFrsnfEN96y3BwbwODGttmMXBU',
		'x-auth-token':sessionStorage.getItem('x-auth-token')
	}
})

export const cachiosInstance = cachios.create(cacheAxiosInstance);

/* eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjEwIiwicm9sZSI6ImNlbnRlciIsImlhdCI6MTY2MjcwNzM1N30.-ShSzicOnm47X4aapxjQUvF2Kn0bAw5YNDwUJVQyhXU 10 */
/* eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjExIiwicm9sZSI6ImNlbnRlciIsImlhdCI6MTY2MjY1NDY2N30.Zerl5YDYtmRCujGx-u7gKdPyTA17OpRfZt5FQ-ABhZQ 11 */
